import {useLocale} from "@/atoms/localeAtom"
import {I18nextProvider, initReactI18next} from "react-i18next"
import {PropsWithChildren, useEffect} from "react"
import {createInstance} from "i18next"
import ICU from "i18next-icu"
import resourcesToBackend from "i18next-resources-to-backend"
import {get} from "lodash-es"

export const lng = "en"
export const fallbackLng = lng
export const supportedLngs = [lng, "ru"]

const locales = {
  en: {
    notification: {
      title: "Notification Settings",
      emailNotifications: "Email Notifications",
      marketingEmails: "Marketing Emails",
    },
    safety: {
      title: "KYC Verification",
      subtitle: "Complete verification to access all platform features.",
      bannerTitle: "Verification via Reown",
      bannerText1: "Your account uses Reown authentication.",
      bannerText2: "To upgrade your verification level, go to the \"Verification\" section.",
      standardLevel: "Standard Level",
      standardDesc: "Email and phone number confirmation.",
      enhancedLevel: "Enhanced Level",
      enhancedDesc: "Submission of passport details.",
      professionalLevel: "Professional Level",
      professionalDesc: "Proof of residential address.",
      completed: "Completed",
      inProgress: "In Progress",
      start: "Start",
    },
    referral: {
      title: "Referral Program",
      description: "Invite friends and earn rewards!",
      subtitle: "Your Referral Link",
      yourReferrals: "Your Referrals",
      statsElements: ['Total referrals', 'Active', 'Total investments', 'Your earnings'],
      yourLevel: {
        topTitle: 'Your level',
        toNextLevel: 'Next level:',
        activeReferralsOr: 'active referrals OR',
        toLvl: 'to'
      },
      referrer: {
        title: 'Have a referral code? Enter it here',
        enterCode: 'Enter code',
        check: 'Check',
      }
    },
    quest: {
      title: "Tasks and achievements",
      subtitle: "Complete tasks to earn bonuses and rewards!",
      subscribe: "Subscribe to our Instagram!",
      follow: "Follow us on X!",
      join: "Join our Telegram!",
      done: "Done",
      complete: "Complete",
    },
    account: {
      title: 'Account',
    },
    sell: {
      to: "Withdraw to",
      select: "Select token",
      button: "Withdraw",
      loading: "Withdrawing…",
    },
    card: {
      title: "Get your ZENEX Card",
      description:
        "Zero transaction fees, MCC restrictions, spending limits up to $100,000 — all this and more with the Zenex card.",
      button: "Order Card",
    },
    investHome: {
      title: "Investment Pools",
      description:
        "Launching two investment pools with different strategies — for conservative and high-yield investing.",
      button: "Zenex Invest",
    },
    invest: {
      title: "Traffic Pools",
      description:
        "Participation in NGR from White Rabbit Casino traffic (Kazakhstan) - whiterabbit.casino \n" +
        "We buy high-quality traffic, convert it into deposits, and share the profit.",
      button: "Follow Updates",
      investFirstRowElements: [
        'years of experience', 'Reg2Dep', 'monthly ROI', 'from GGR= NGR'
      ],
      poolsTitle: 'Available pools',
      pools: ['members', 'types of pools', 'months', 'ZNX\n' + 'total limit'],
      poolsOffers: {
        titlesSafe: ['100% capital return guarantee', '34-42,5% from GGR', 'Payouts in USDC'],
        titlesGrowth: ['Maximum upside from ZNX', '8,5-12,75% from GGR', 'Payouts in USDC'],
        amountStaked: 'Amount Staked',
      },
      poolsOffersRow: {
        payoutsSafe: ['34% from GGR', '38,25% from GGR', '42,5% from GGR'],
        payoutsGrowth: ['8,5% from GGR', '10.625% from GGR', '12,75% from GGR'],
      },
      poolButton: 'Enter the pool',
      nrgComeFrom: {
        title: 'Where does NGR for payouts come from?',
        nrgElements: {
          titles: ['GGR from players', 'Minus 15%', '= NGR', 'To pool participants'],
          subTitles: ['Gross Gaming Revenue', 'Casino administrative\n' + 'expenses', 'Net Gaming Revenue', 'According to tier\n' + 'and pool type'],
        },
        description: 'Example: GGR $100k → NGR $85k → Participants receive between $8.5k and $42.5k, depending on pool and tier.'
      },
      howItWorks: {
        title: 'How It Works?',
        elements: {
          titles: ['Deposit Collection', 'Traffic Acquisition', 'Profit Generation', 'Participant Payouts', 'Deposit Return'],
          descriptions: [
            'Participants deposit 2NX tokens up\n' + 'to a limit of 230k tokens',
            'We purchase high-quality traffic\n' + 'for White Rabbit Casino',
            'Players wager → GGR →\n' + 'minus 15% fees → NGR',
            'Monthly % of NGR distributed\n' + 'based on tier and pool type',
            'Tokens will be returned after 12 months\n' + 'based on your chosen pool'
          ],
        }
      },
      faq: {
        title: 'Frequently Asked Questions',
        questions: [
          'What are Zenex Traffic Pools?',
          'What\'s the difference between Safe Pool and Growth Pool?',
          'How often are payouts made?',
          'Can I exit the pool early?',
          'What if pool doesn\'t reach target amount?',
          'Can I participate in multiple pools simultaneously?'
        ],
        answers: [
          'Zenex Traffic Pools is RWA tokenization of real casino brand business. You acquire ZNX tokens, place them in traffic acquisition pools for <span>whiterabbit.casino</span>, and receive a fixed percentage of Gross Gaming Revenue (GGR) every month\n' +
          'for 12 months.',
          'Safe Pool: Get 34-42.5% of GGR + guarantee of 100% return in USD equivalent. Protection against ZNX price decline.\n' +
          'Growth Pool: Get 8.5-12.75% of GGR + get your ZNX tokens back after 12 months. Higher growth potential when token price rises.',
          'Payouts are made monthly in USDC on the 5th of each month for 12 months,\n' +
          'if GGR is positive. Funds arrive to your ZNX Hub balance, you can withdraw immediately or reinvest.',
          'No, early exit is impossible. Funds are locked in smart contract for 12 months.\n' +
          'This allows us to plan marketing campaigns and guarantee stable returns. Participate only with spare funds.',
          'Pool will launch anyway, as the brand buys traffic including with their own funds. Final distribution proportions are determined after the purchase month ends.',
          'Yes, you can diversify between different pools, types (Safe/Growth)\n' +
          'and even future directions.'
        ]
      },
      betshops: {
        title: 'Betshops',
      },
      questions: {
        title: 'Still Have Questions?',
        button: 'Get in touch'
      },
      enterToPoolDialog: {
        title: 'ZNX Total Amount',
        buttonTopUp: 'Top up balance',
        buttonEnterPool: 'Enter the pool',
        choosePlan: 'Choose your plan',
        inputLabel: 'Enter ZNX amount',
        inputMessages: {
          exceedsBalance: 'Exceeds Balance',
          increase: {
            toIncrease: 'To increase your',
            addAdditional: 'add an additional',
            safe: {
              toAdvanced: 'NGR to 45%',
              toPremium: 'NGR to 50%',
            },
            growth: {
              toAdvanced: 'NGR to 12%',
              toPremium: 'NGR to 15%',
            }
          }
        }
      },
      myActivePools: {
        title: 'My Active Pools',
        myActivePoolElements: ['Staked', 'Current\n' + 'Plan', 'GGR'],
        growUp: 'Upgrade your plan to boost earnings!',
        missing: 'Missing',
        buttonStats: 'View Stats',
        buttonAddZNX: 'Add ZNX',
        months: {
          january: 'January',
          february: 'February',
          march: 'March',
          april: 'April',
          may: 'May',
          june: 'June',
          july: 'July',
          august: 'August',
          september: 'September',
          october: 'October',
          november: 'November',
          december: 'December',
        }
      },
      stats: {
        title: 'White Rabbit Analytics Dashboard',
        description: 'Operational Analytics • Kazakhstan',
        claimButton: 'Claim',
        chartPerios: ['1d', '1w', '1m'],
        chartLine: 'Dynamics of GGR',
        barLine: 'Dynamics Active Players',
        months: {
          january: 'January',
          february: 'February',
          march: 'March',
          april: 'April',
          may: 'May',
          june: 'June',
          july: 'July',
          august: 'August',
          september: 'September',
          october: 'October',
          november: 'November',
          december: 'December',
        },
        yourPayouts: 'Your',
      },
      transparency: {
        title: 'Transparency',
        lastUpdated: 'Last updated:',
        dataSource: 'Data source:',
        crossGamingRevenue: 'Gross Gaming Revenue',
        adminFee: 'Admin Fee (15%)',
        netGamingRevenue: 'Net Gaming Revenue',
        totalDeposits: 'Total Deposits',
        playersCount: 'Players Count',
      },
      overview: {
        title: 'Personal Investment Overview',
        totalInvested: 'Total invested',
        totalEarned: 'Total earned',
        nextPayout: 'Next payout',
        poolShare: 'Your pool share:',
        roi: 'ROI:',
        paymentDate: 'Payment date:',
        poolMetrics: 'Pool Metrics',
        poolSize: 'Pool Size',
        investors: 'Investors',
        staked: 'Staked',
        players: 'Players',
      },
      totalStaked: {
        title: 'Total Staked in Pools',
        button: 'Invest in Pools'
      },
      whiteRabbitPromo: {
        title: 'White Rabbit Pool Stats',
        subtitle: 'See the numbers, calculate your earnings, join now',
        button: 'Open Statistics'
      },
      poolMetrics: {
        title: 'Pool Metrics',
        metricsElements: ['Pool Size', 'Investors', 'Staked', 'Players']
      }
    },
    buy: {
      currency: "Currency",
      network: "Network",
      sum: "Amount",
      min: "Minimum",
      max: "Maximum",
      loading: "Loading…",
      buy: "Buy",
      approve: "Transfer {amount} {currency} to address:",
    },
    claim: {
      have: "You have",
      available: "tokens available",
      description:
        'Click the "Claim" button to add them to your account balance.',
      button: "Claim",
      check: "Check",
      total: "Your total score",
      tooltip: "Optional field",
      notice: {
        white: "Enter the bonus code to get",
        green: "x2 ZNX tokens.",
      },
      optional: "Optional field",
    },
    page: {
      title: {
        green: "Welcome to",
        yellow: "Zenex Hub!",
      },
      descriptions1:
        "Thank you for believing in us and wanting to grow with us!",
      descriptions2:
        "We’re in the final testing phase and will soon unveil our full functionality.",
      descriptions3: "Play now to claim your",
      descriptions4: "free tokens",
      descriptions5: "—don’t miss out!",
      buttons: {
        play: "Play Treasure Hunt",
        get: "Get ZNX",
      },
      notice: "This offer is available for a short time only.",
      back: 'Back'
    },
    balance: {
      title: "Your NFT collections",
    },
    header: {
      title: {
        profile: "Profile Settings",
      },
      welcome: "Welcome {username}!",
      button: {
        logout: "Logout",
      },
      labels: {
        address: "Address:",
        caipAddress: "CAIP Address:",
        status: "Status:",
      },
    },
    login: {
      title: {
        green: "Welcome to",
        white: "Zenex Hub!",
      },
      button: "Connect",
    },
    plans: {
      title: "Zenex Investment Access Programs",
      welcome: "Welcome {username}!",
      cards: {
        silver: {
          title: "Silver Tier",
          subtitle: "Early Investor",
          items: [
            "1,000 spots",
            "ZNX Play: Staking ×1.5 (6 mo.)",
            "ZNX Arena: 5 standard cards + 1 gold",
            "ZNX Invest: Exclusive pool access",
            "Bonus: 850 ZNX",
          ],
        },
        gold: {
          title: "Gold Tier",
          subtitle: "Strategic Partner",
          items: [
            "200 spots",
            "ZNX Play: Staking ×2 (12 mo.)",
            "ZNX Arena: 8 standard cards + 2 gold",
            "ZNX Invest: +10% pool yield",
            "Bonus: 4,200 ZNX",
          ],
        },
        platinum: {
          title: "Platinum Tier",
          subtitle: "VIP Investor",
          items: [
            "50 spots",
            "ZNX Play: Staking ×3 (12 mo.)",
            "ZNX Arena: 10 standard cards + 3 gold",
            "ZNX Invest: +20% pool yield",
            "Private insider chat",
            "Bonus: 12,500 ZNX",
          ],
        },
        diamond: {
          title: "Diamond Tier",
          subtitle: "Founding Partner",
          items: [
            "20 spots",
            "ZNX Play: Staking ×4 (12 mo.)",
            "ZNX Arena: 10 standard cards + 5 gold",
            "ZNX Invest: +30% yield + guaranteed allocations",
            "Private chat + platform influence",
            "Hall of Fame mention",
            "Bonus: 12,500 ZNX",
          ],
        },
      },
      button: "Buy",
      available: "Available Positions",
      benefits: "Benefits",
    },
    opportunities: {
      cards: {
        play: {
          title: "ZNX Play",
          description: "Hold ZNX, earn rewards— zero effort required.",
        },
        invest: {
          title: "ZNX Invest",
          description:
            "Own betting shops from $100 and grow to a franchise empire.",
        },
        cases: {
          title: "Cases & Chests",
          description: "Open cases for random rewards, boosters, or perks.",
        },
        arena: {
          title: "ZNX Arena",
          description:
            "Profit from promoters competing for clients in a business reality show.",
        },
      },
      button: "Coming soon",
      buttonOpen: "Open"
    },
    meta: {
      title: "English",
    },
    wallet: {
      title: {
        main: 'Wallet',
        balance: 'Total Balance',
        transaction: 'Transaction History',
        calendar: 'Payment Calendar',
        payments: 'Upcoming Payments',
      },
      chooseAssets: 'Choose an asset',
      walletNetworkDeposit: 'Deposit network',
      walletNetworkWithdraw: 'Withdraw network',
      address: 'Address',
      enterAddress: 'Enter address',
      withdrawAmount: 'Withdraw amount',
      doubleCheckWithdraw: 'Please double check the withdraw address!',
      doubleCheckDeposit: 'Please double check the deposit address!',
      sendingFundsToWrong: 'Sending funds to the wrong address may result in the irretrievable loss' + '\n' + 'of your cryptocurrency.',
      theProcedureUpTo48Hours: 'The procedure can take up to 48 hours!',
      swap: 'Confirm',
      sell: 'Sell',
      receive: 'Receive',
      selectToken: 'Select token',
      selectNetwork: 'Select network',
      swapReview: 'Please review transaction details' + '\n' + 'before confirmation!',
      depositAddress: 'Deposit address',
      walletDepositLoading: 'Please wait, your deposit address is being generated...',
      swapPage: {
        youSend: 'You Send',
        youReceive: 'You Receive',
        swapMinDeposit: 'Min Deposit',
        fee: 'Fee',
        feeWithdraw: 'Fee Withdrawal',
        finish: 'Finish',
      }
    },
    paymentProcess: {
      awaitingPayment: 'Awaiting Payment',
      confirmed: 'Confirmed',
      swapped: 'Swapped',
      sending: 'Sending ZNX',
      usualTime: 'This usually takes 5-30 minutes.'
    },
    transactionStatus: {
      complete: 'Transaction Complete!',
      failed: 'Transaction Failed',
      successSend: 'ZNX has been successfully sent to your wallet.',
      errorOccurred: 'An error occurred while processing the transaction.',
      viewOnExplorer: 'View on Block Explorer',
      contactSupport: 'Contact Support'
    }
  },
  ru: {
    notification: {
      title: "Настройки уведомлений",
      emailNotifications: "Уведомления по электронной почте",
      marketingEmails: "Маркетинговые рассылки",
    },
    safety: {
      title: "KYC Верификация",
      subtitle: "Пройдите верификацию для доступа ко всем функциям платформы.",
      bannerTitle: "Верификация через Reown",
      bannerText1: "Ваш аккаунт использует аутентификацию Reown.",
      bannerText2: "Для повышения уровня верификации перейдите в раздел \"Верификация\".",
      standardLevel: "Стандартный уровень",
      standardDesc: "Подтверждение электронной почты и номера телефона.",
      enhancedLevel: "Расширенный уровень",
      enhancedDesc: "Предоставление паспортных данных.",
      professionalLevel: "Профессиональный уровень",
      professionalDesc: "Подтверждение адреса проживания.",
      completed: "Выполнено",
      inProgress: "В процессе",
      start: "Начать",
    },
    referral: {
      title: "Реферальная программа",
      description: "Приглашайте друзей и получайте награды!",
      subtitle: "Ваша реферальная ссылка",
      yourReferrals: "Ваши рефералы",
      statsElements: ['Всего рефералов', 'Активных', 'Объем инвестиций', 'Ваш доход'],
      yourLevel: {
        topTitle: 'Ваш уровень',
        toNextLevel: 'До следующего уровня:',
        activeReferralsOr: 'активных рефералов или ',
        toLvl: 'до уровня'
      },
      referrer: {
        title: 'Есть реферальный код? Введите его здесь',
        enterCode: 'Введите код',
        check: 'Проверить',
      }
    },
    quest: {
      title: "Задачи и достижения",
      subtitle: "Выполняйте задания, чтобы получать бонусы и награды!",
      subscribe: "Подпишитесь на наш Instagram!",
      follow: "Подпишитесь на нас в X!",
      join: "Присоединяйтесь к нашему Telegram!",
      done: "Готово",
      complete: "Выполнить",
    },
    account: {
      title: 'Аккаунт',
    },
    sell: {
      to: "Куда вывести",
      select: "выберите токен",
      button: "Вывести",
      loading: "Вывод…",
    },
    card: {
      title: "Оформить карту ZENEX",
      description:
        "0 комиссий за транзакции, ограничения по МСС, расходы до $100 000 — все это и многое другое в карте Zenex.",
      button: "Заказать карту",
    },
    investHome: {
      title: "Инвестиционные пулы",
      description:
        "Запуск двух инвестиционных пулов с разными стратегиями — для консервативного и высокодоходного инвестирования.",
      button: "Zenex Invest",
    },
    invest: {
      title: "Traffic Pools",
      description:
        "Участие в NGR от трафика White Rabbit Casino (Казахстан).\n" +
        "Покупаем качественный трафик, конвертим в депозиты, делим прибыль.",
      button: "Следить за обновлениями",
      investFirstRowElements: [
        'лет работы', 'Reg2Dep', 'мес. окупаемость', 'от GGR = NGR'
      ],
      poolsTitle: 'Текущий набор пулов',
      pools: ['участников', 'типа пулов', 'месяцев', 'ZNX\n' + 'общий лимит'],
      poolsOffers: {
        titlesSafe: ['Гарантия возврата 100%', '34-42,5% от GGR', 'Выплаты в USDC'],
        titlesGrowth: ['Максимальная доходность', '8,5-12,75% от GGR', 'Выплаты в USDC'],
        amountStaked: 'Вложено средств'
      },
      poolsOffersRow: {
        payoutsSafe: ['34% от GGR', '38,25% от GGR', '42,5% от GGR'],
        payoutsGrowth: ['8,5% от GGR', '10.625% от GGR', '12,75% от GGR'],
      },
      poolButton: 'Войти в пул',
      nrgComeFrom: {
        title: 'Откуда берется NGR для выплат',
        nrgElements: {
          titles: ['GGR от игроков', 'Минус 15%', '= NGR', 'Участникам пулов'],
          subTitles: ['Валовая игровая выручка', 'Административные\n' + 'расходы казино', 'Net Gaming Revenue', 'Согласно tier и типу'],
        },
        description: 'Пример: GGR $100k → NGR $85k → участники получают от $8.5k до $42.5k в зависимости от пула и tier'
      },
      howItWorks: {
        title: 'Как это работает?',
        elements: {
          titles: ['Сбор депозитов', 'Закупка трафика', 'Генерация прибыли', 'Выплаты участникам', 'Возврат токенов'],
          descriptions: [
            'Участники депонируют ZNX\n' + 'до лимита 230k токенов',
            'Покупаем качественный трафик\n' + 'для White Rabbit Casino',
            'Казино зарабатывает GGR\n' + '= "проигрыш" - "выигрыш" игроков',
            'Ежемесячно % от GGR в USDC\n' + 'согласно tier и типу пула',
            'Через 12 месяцев возврат\n' + 'согласно выбранному пулу'
          ],
        }
      },
      questions: {
        title: 'Остались вопросы?',
        button: 'Связаться с нами'
      },
      enterToPoolDialog: {
        title: 'Баланс ZNX',
        buttonTopUp: 'Пополнить баланс',
        buttonEnterPool: 'Войти в пул',
        choosePlan: 'Выберите план',
        inputLabel: 'Введите сумму ZNX',
        inputMessages: {
          exceedsBalance: 'Недостаточно средств',
          increase: {
            toIncrease: 'Чтобы увеличить ваш',
            addAdditional: 'добавьте еще',
            safe: {
              toAdvanced: 'NGR до 45%',
              toPremium: 'NGR до 50%',
            },
            growth: {
              toAdvanced: 'NGR до 12%',
              toPremium: 'NGR до 15%',
            }
          }
        }
      },
      myActivePools: {
        title: 'Мои активные пулы',
        myActivePoolElements: ['Вклад', 'План', 'GGR'],
        growUp: 'Повысьте план и увеличьте доходность!',
        missing: 'Не хватает',
        buttonStats: 'Посмотреть статистику',
        buttonAddZNX: 'Добавить ZNX',
        months: {
          january: 'Январь',
          february: 'Февраль',
          march: 'Март',
          april: 'Апрель',
          may: 'Май',
          june: 'Июнь',
          july: 'Июль',
          august: 'Август',
          september: 'Сентябрь',
          october: 'Октябрь',
          november: 'Ноябрь',
          december: 'Декабрь',
        }
      },
      stats: {
        title: 'White Rabbit статистика',
        description: 'Операционная аналитика казино • Казахстан',
        claimButton: 'Получить',
        chartLine: 'Динамика GGR',
        barLine: 'Динамика активных игроков',
        chartPerios: ['1д', '1н', '1м'],
        months: {
          january: 'Январь',
          february: 'Февраль',
          march: 'Март',
          april: 'Апрель',
          may: 'Май',
          june: 'Июнь',
          july: 'Июль',
          august: 'Август',
          september: 'Сентябрь',
          october: 'Октябрь',
          november: 'Ноябрь',
          december: 'Декабрь',
        },
        yourPayouts: 'Ваши выплаты за',
      },
      transparency: {
        title: 'Детализация',
        lastUpdated: 'Обновлено:',
        dataSource: 'Источник Данных:',
        crossGamingRevenue: 'Валовой игровой доход',
        adminFee: 'Административный сбор (15%)',
        netGamingRevenue: 'Чистый игровой доход',
        totalDeposits: 'Общая сумма депозитов',
        playersCount: 'Количество игроков',
      },
      overview: {
        title: 'Обзор личных инвестиций',
        totalInvested: 'Общая сумма инвестиций',
        totalEarned: 'Общий доход',
        nextPayout: 'Следующая выплата',
        poolShare: 'Ваша доля в пуле:',
        roi: 'ROI:',
        paymentDate: 'Дата выплаты:',
        poolMetrics: 'Метрики пула',
        poolSize: 'Размер пула',
        investors: 'Инвесторов',
        staked: 'Инвестировано',
        players: 'Игроков',
      },
      totalStaked: {
        title: 'Всего инвестировано',
        button: 'Инвестировать в пулы'
      },
      whiteRabbitPromo: {
        title: 'Промо-статистика White Rabbit',
        subtitle: 'Смотрите цифры, считайте доход, присоединяйтесь',
        button: 'Открыть статистику'
      },
      poolMetrics: {
        title: 'Метрики пула',
        metricsElements: ['Размер пула', 'Инвесторов', 'Инвестировано', 'Игроков']
      }
    },
    buy: {
      currency: "Валюта",
      network: "Сеть",
      sum: "Сумма",
      min: "Минимум",
      max: "максимум",
      loading: "Запрос…",
      buy: "Купить",
      approve: "Переведите {amount} {currency} на адрес:",
    },
    claim: {
      have: "У Вас есть",
      available: "токенов",
      description:
        'Нажмите кнопку "Заклеймить" и добавьте их к себе на баланс.',
      button: "Заклеймить",
      check: "Проверить",
      total: "Ваш общий счёт",
      tooltip: "Опциональное поле",
      notice: {
        white: "Введите бонусный код, чтобы получить",
        green: "x2 токенов ZNX.",
      },
      optional: "Необязательное поле",
    },
    page: {
      title: {
        green: "Добро пожаловать в",
        yellow: "Zenex Hub!",
      },
      descriptions1:
        "Спасибо, что верите в нас и хотите развиваться вместе с нами!",
      descriptions2:
        "Мы уже на стадии финального тестирования и скоро представим вам наш функционал.",
      descriptions3: "Успейте получить свои токены",
      descriptions4: "бесплатно",
      descriptions5: "— играйте прямо сейчас!",
      buttons: {
        play: "Играть в Treasure Hunt",
        get: "Забрать ZNX",
      },
      notice: "Данное предложение ограничено во времени.",
      back: 'Назад'
    },
    balance: {
      title: "Ваши NFT коллекции",
    },
    header: {
      welcome: "Добро пожаловать, {username}!",
      button: {
        logout: "Выйти",
      },
      labels: {
        address: "Адрес:",
        caipAddress: "CAIP Адрес:",
        status: "Статус:",
      },
    },
    login: {
      title: {
        green: "Добро пожаловать в",
        white: "Zenex Hub!",
      },
      button: "Присоединиться",
    },
    plans: {
      welcome: "Добро пожаловать, {username}!",
      title: "Программы инвестиционного доступа Zenex",
      cards: {
        silver: {
          title: "Серебряный уровень",
          subtitle: "Ранний инвестор",
          items: [
            "1 000 мест",
            "ZNX Play: Стейкинг ×1.5 (6 мес.)",
            "ZNX Arena: 5 стандартных карт + 1 золотая",
            "ZNX Invest: Эксклюзивный доступ к пулу",
            "Бонус: 850 ZNX",
          ],
        },
        gold: {
          title: "Золотой уровень",
          subtitle: "Стратегический партнёр",
          items: [
            "200 мест",
            "ZNX Play: Стейкинг ×2 (12 мес.)",
            "ZNX Arena: 8 стандартных карт + 2 золотые",
            "ZNX Invest: +10 % доходности пула",
            "Бонус: 4 200 ZNX",
          ],
        },
        platinum: {
          title: "Платиновый уровень",
          subtitle: "VIP-инвестор",
          items: [
            "50 мест",
            "ZNX Play: Стейкинг ×3 (12 мес.)",
            "ZNX Arena: 10 стандартных карт + 3 золотые",
            "ZNX Invest: +20 % доходности пула",
            "Частный инсайдерский чат",
            "Бонус: 12 500 ZNX",
          ],
        },
        diamond: {
          title: "Бриллиантовый уровень",
          subtitle: "Основатель-партнёр",
          items: [
            "20 мест",
            "ZNX Play: Стейкинг ×4 (12 мес.)",
            "ZNX Arena: 10 стандартных карт + 5 золотых",
            "ZNX Invest: +30 % доходности + гарантированные аллокации",
            "Частный чат + влияние на платформу",
            "Упоминание в Зале славы",
            "Бонус: 12 500 ZNX",
          ],
        },
      },
      button: "Купить",
      available: "Доступные позиции",
      benefits: "Преимущества",
    },
    opportunities: {
      cards: {
        play: {
          title: "ZNX Play",
          description: "Держите ZNX, получайте награды — без усилий.",
        },
        invest: {
          title: "ZNX Invest",
          description: "Инвестируйте от $100, растите до империи франшиз.",
        },
        cases: {
          title: "Кейсы и сундуки",
          description:
            "Открывайте кейсы для случайных наград, бустеров и привилегий.",
        },
        arena: {
          title: "ZNX Arena",
          description:
            "Зарабатывайте на промоутерах, соревнующихся за клиентов в бизнес-реалити.",
        },
      },
      button: "Скоро",
      buttonOpen: "Перейти"
    },
    meta: {
      title: "Русский",
    },
    wallet: {
      title: {
        main: 'Кошелек',
        balance: 'Общая сумма',
        transaction: 'История транзакций',
        calendar: 'Календарь выплат',
        payments: 'Ближайшие выплаты',
      },
      chooseAssets: 'Выберите валюту',
      walletNetworkDeposit: 'Сеть',
      walletNetworkWithdraw: 'Сеть',
      address: 'Адрес',
      enterAddress: 'Введите адрес',
      withdrawAmount: 'Сумма',
      doubleCheckWithdraw: 'Пожалуйста, дважды проверьте адрес!',
      doubleCheckDeposit: 'Пожалуйста, дважды проверьте адрес депозита!',
      sendingFundsToWrong: 'Отправка средств на неправильный адрес может привести' + '\n' + 'к безвозвратной потере вашей криптовалюты.',
      theProcedureUpTo48Hours: 'Процедура может занять до 48 часов!',
      swap: 'Обменять',
      sell: 'Продать',
      receive: 'Получить',
      selectToken: 'Выберите токен',
      selectNetwork: 'Выберите сеть',
      swapReview: 'Пожалуйста, проверьте детали транзакции' + '\n' + 'перед подтверждением!',
      depositAddress: 'Адрес',
      walletDepositLoading: 'Пожалуйста, подождите' + '\n' + ' — генерируем ваш депозит-адрес...',
      swapPage: {
        youSend: 'Вы отправляете',
        youReceive: 'Вы получаете',
        swapMinDeposit: 'Минимальный депозит',
        fee: 'Комиссия',
        feeWithdraw: 'Комиссия за вывод',
        finish: 'Готово',
      }
    },
    paymentProcess: {
      awaitingPayment: 'Ожидание платежа',
      confirmed: 'Подтверждено',
      swapped: 'Обмен',
      sending: 'Отправка ZNX',
      usualTime: 'Обычно это занимает 5-30 минут.'
    },
    transactionStatus: {
      complete: 'Транзакция успешно выполнена!',
      failed: 'Что-то пошло не так',
      successSend: 'ZNX отправлены на ваш кошелек.',
      errorOccurred: 'При обработке транзакции возникла ошибка',
      viewOnExplorer: 'Открыть в блок-эксплорере',
      contactSupport: 'Связаться с поддержкой'
    }
  },
}

export const i18n = createInstance({
  lng,
  supportedLngs,
  fallbackLng,
  interpolation: {
    escapeValue: false,
  },
  react: {
    useSuspense: true,
    transSupportBasicHtmlNodes: true,
    transKeepBasicHtmlNodesFor: ['span'],
  },
  joinArrays: false,
  initAsync: false,
})
  .use(ICU)
  .use(
    resourcesToBackend((lng: string, ns: string) =>
      get(locales, [lng, ...ns.split(/[/.]/).filter(Boolean)]),
    ),
  )
  .use(initReactI18next)

await i18n.init()

export function AppI18nProvider({children}: PropsWithChildren) {
  const [locale] = useLocale()

  useEffect(() => {
    i18n.changeLanguage(locale)
  }, [locale])

  return <I18nextProvider i18n={i18n}>{children}</I18nextProvider>
}
